const cmsConfig = {
  data() {
    return {
      // 操作类型定义开始
      OPERATION_LIST: 10, // 列表
      OPERATION_ADD: 20,  // 添加/编辑/详情
      OPERATION_EDIT: 30, // 编辑
      OPERATION_DETAIL: 40, // 详情
      OPERATION_DELETE: 50, // 删除
      OPERATION_IMPORT: 60, // 导入
      OPERATION_EXPORT: 70,  // 批量导出
      OPERATION_SEARCH: 80,  // 搜索
      OPERATION_STATUS: 90,  // 状态修改
      OPERATION_FILTER: 100,  // 筛选标签
      OPERATION_DOWNLOAD: 110,  // 下载
      OPERATION_MESSAGE: 120,  // 消息提醒
      OPERATION_CHART: 130,  // 图表
      OPERATION_PARAMS: 140,  // 参数管理
      OPERATION_EXEC: 150,  // 执行函数
      OPERATION_IFRAME: 160,  // IFrame
      OPERATION_EXPORTWORD: 170, // 导出word文档
      OPERATION_SELF: 180,  // 定制化功能点
      OPERATION_MULTI_ADD: 190,  // 批量写入子表
      OPERATION_MULTI_EDIT: 200,  // 批量编辑
      OPERATION_DIMENSIONAL_CHART: 210,  // 一维图表
      OPERATION_DEALGROUP: 220, // 功能点链接集合
      OPERATION_EMAIL: 230, // 发送邮件
      // 操作类型定义结束
      // 定义模块类型开始
      MODULE_COMMON: 10,  // 公共模块
      MODULE_SELF: 20, // 私有模块
      // 定义模块类型结束
      // 定义操作摆放位置开始
      POS_LEFT_TOP: 10,   // 左上
      POS_RIGHT_TOP: 20,  // 右上
      POS_LEFT_BOTTOM: 30,  // 左下
      // 定义操作摆放位置结束
      // 定义筛选控件类型开始
      FILTER_INPUT: 10, // 输入框
      FILTER_SELECT: 20, // 下拉框
      FILTER_RANGE: 30, // 范围
      FILTER_DATERANGE: 40, // 时间搜索
      FILTER_FOREIGNKEY: 50, // 外键下拉框
      FILTER_CHECKBOX: 60, // 复选框
      FILTER_FOREIGNKEYCHECKBOX: 70, // 外键复选框
      // 定义筛选控件类型结束
      // 定义筛选控件显示方式开始
      FILTER_SHOW_NORMAL: 10,
      FILTER_SHOW_ADVANCE: 20,
      // 定义筛选控件显示方式结束
      // // 定义页面类型开始
      // PAGE_LIST: 10,  // 列表
      // PAGE_ADD: 20,  // 添加/编辑/详情
      // PAGE_EDIT: 30,  // 编辑
      // PAGE_DETAIL: 40,  // 详情
      // PAGE_CHART: 50,  // 图表
      // PAGE_PARAMS: 60,  // 参数管理
      // // 定义页面类型结束
      // 定义表单显示类型开始
      FORM_SHOW_PAGE: 10, // 表单显示类型为页面
      FORM_SHOW_DIALOG: 20, // 表单显示类型为弹窗
      // 定义表单显示类型结束
      // 定义功能集层级开始
      LEVEL_ONE: 10,    // 一级层级
      LEVEL_TWO: 20,     // 二级层级
      // 定义功能集层级结束
      // 定义链接方式开始
      LINK_DOWNLOAD: 10,      // 下载
      LINK_JUMP: 20,    // 功能集跳转
      LINK_SENDPARAMS: 30,     // 传参给同页一级功能集
      LINK_SHOWRELATE: 40,     // 查看关联数据
      IMG_SHOW: 50, // 实例化图片
      LINK_SUBRELATE: 60, // 子表数据关联
      // 定义链接方式结束
      // 定义功能展示方式开始
      CONTENT_TYPE_NORMAL: 10,      // 一般
      CONTENT_TYPE_TAB: 20,    // tab
      // 定义功能展示方式结束
      // 定义参数字典字段类型开始
      DICTIONARY_CHECKBOX: 10,  // 复选框
      DICTIONARY_RADIO: 20, // 单选框
      DICTIONARY_NUMBERTEXT: 30, // 文本框（数字）
      DICTIONARY_TEXT: 40, // 文本框
      // 定义参数字典字段类型结束
      // 定义导出类型开始
      EXPORT_LIST: 10, // 导出配置跟列表一样
      EXPORT_SELF: 20,  // 自定义导出配置
      // 定义导出类型结束
      // 定义实例化时，列表行数据样式类型 开始
      ROW_STYLE_TYPE_BBBC: 10,  // 蓝底黑字
      ROW_STYLE_TYPE_BBRC: 20,  // 蓝底红字
      ROW_STYLE_TYPE_RBWC: 30,  // 红底白字
      // 定义实例化时，列表行数据样式类型 结束
      // 定义列表操作区自定义操作方式开始
      SELFHANDLE_LINK: 10,          // 外链
      SELFHANDLE_DIALOG: 20,        // 弹窗跳转功能集
      SELFHANDLE_PAGE: 30,          // 页面跳转功能集
      // 定义列表操作区自定义操作方式结束
      // 定义功能点集合展示方式开始
      DEALGROUP_SHOW_BTN: 10,         // 按钮形式
      DEALGROUP_SHOW_TABLE: 20,       // 列表形式
      // 定义功能点集合展示方式结束
      // 定义操作权限开始
      DEAL_AUTH_NOUSE: 10,   // 不可见
      DEAL_AUTH_DISABLED: 20  // 禁用
      // 定义操作权限结束
    }
  }
}

export default cmsConfig



// WEBPACK FOOTER //
// ./src/config/cmsConfig.js